export default __webpack_public_path__ + "static/media/CULACImage.5ad92f4b.JPG";